import type { PeSchool } from '../ProgramEvaluation/types';

export type DistrictAverages = {
  newcomerShare: number | null;
  ltelShare: number | null;
  reclassificationRate: number | null;
};

export type EnrolmentRank = { rank: number; total: number };

function key(name: string): string {
  return name.trim().toLowerCase();
}

export function findPeSchool(bySchool: PeSchool[], name: string): PeSchool | null {
  const wanted = key(name);
  if (wanted === '') return null;
  return bySchool.find((school) => key(school.school_name) === wanted) ?? null;
}

export function districtAverages(bySchool: PeSchool[]): DistrictAverages {
  const totalEls = bySchool.reduce((sum, school) => sum + school.el_count, 0);
  if (totalEls === 0) {
    return { newcomerShare: null, ltelShare: null, reclassificationRate: null };
  }
  const newcomers = bySchool.reduce((sum, school) => sum + school.newcomer_count, 0);
  const ltels = bySchool.reduce((sum, school) => sum + school.ltel_count, 0);
  const rated = bySchool.every((school) => school.reclassification_rate !== null);
  const reclassified = bySchool.reduce(
    (sum, school) => sum + (school.reclassification_rate ?? 0) * school.el_count,
    0,
  );
  return {
    newcomerShare: newcomers / totalEls,
    ltelShare: ltels / totalEls,
    reclassificationRate: rated ? reclassified / totalEls : null,
  };
}

export function enrolmentRank(bySchool: PeSchool[], name: string): EnrolmentRank | null {
  const wanted = key(name);
  const ordered = [...bySchool].sort(
    (a, b) => b.el_count - a.el_count || a.school_name.localeCompare(b.school_name),
  );
  const index = ordered.findIndex((school) => key(school.school_name) === wanted);
  if (index === -1) return null;
  return { rank: index + 1, total: ordered.length };
}
